import React, { useState, useEffect, useContext } from 'react';
import './footer.scss';
import http from '@/server';

function Footer() {
  const [state, setState] = useState({
    count: 0,
  });
  useEffect(() => {
    // getIp((ip) => {
    getRecord(window.localStorage.getItem('ip'));
    // });
    return () => {};
  }, []);

  const getRecord = (ip) => {
    let data = {
      ip,
    };
    http.post('/census/add_record', data).then((res) => {
      if (res.data.error_code == 0) {
        setState({
          ...state,
          count: res.data.data.count,
        });
      }
    });
  };

  // const getIp = (onNewIP) => {
  //   var myPeerConnection =
  //     window.RTCPeerConnection ||
  //     window.mozRTCPeerConnection ||
  //     window.webkitRTCPeerConnection;
  //   var pc = new myPeerConnection({
  //       iceServers: [],
  //     }),
  //     noop = function () {},
  //     localIPs = {},
  //     ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g,
  //     key;

  //   function iterateIP(ip) {
  //     if (!localIPs[ip]) onNewIP(ip);
  //     localIPs[ip] = true;
  //   }

  //   //create a bogus data channel
  //   pc.createDataChannel('');

  //   // create offer and set local description
  //   pc.createOffer()
  //     .then(function (sdp) {
  //       sdp.sdp.split('\n').forEach(function (line) {
  //         if (line.indexOf('candidate') < 0) return;
  //         line.match(ipRegex).forEach(iterateIP);
  //       });

  //       pc.setLocalDescription(sdp, noop, noop);
  //     })
  //     .catch(function (reason) {
  //       // An error occurred, so handle the failure to connect
  //     });

  //   //listen for candidate events
  //   pc.onicecandidate = function (ice) {
  //     if (
  //       !ice ||
  //       !ice.candidate ||
  //       !ice.candidate.candidate ||
  //       !ice.candidate.candidate.match(ipRegex)
  //     )
  //       return;
  //     ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
  //   };
  // };
  return (
    <div className="footer">
      <div className="footer-t"></div>
      <div className="footer-b center">
        <div>
          <p>
            <span
              onClick={() => {
                window.open('https://beian.miit.gov.cn/', '_blank');
              }}
            >
              苏ICP备05000005号
            </span>
            {'　'}
            Copyright ©2010　www.jsic.cn
          </p>
          <p>江苏省通信学会 版权所有 地址: 江苏省南京市中山北路301号</p>
          {/* <p>
            <span
              onClick={() => {
                window.open('http://www.jsic.cn/master/', '_blank');
              }}
            >
              后台管理
            </span>
            <span
              onClick={() => {
                window.open('http://www.fedtech.cc/', '_blank');
              }}
            >
              技术支持: 江苏连邦信息技术有限公司
            </span>
          </p> */}
          <p>
            <span>电话:025-83342299 访问量: {state.count}</span>
            <span
              onClick={() => {
                window.open('http://www.jsic.cn/master/', '_blank');
              }}
            >
              后台管理
            </span>
          </p>
          <p><span><img src={require('@/assets/home/icon.png').default} alt="" /></span><a href="https://beian.mps.gov.cn/#/query/webSearch?code=32010602012340" rel="noreferrer"
    target="_blank">苏公网安备32010602012340号</a></p>
        </div>
      </div>
    </div>
  );
}

export default Footer;
